export const INIT_PAYMENT = 'INIT_PAYMENT';
export const SET_PAYMENT_PAY_WAY = 'SET_PAYMENT_PAY_WAY';

export const VERIFICATION_SUCCESS = 'VERIFICATION_SUCCESS';

export const PAY_METHODS_FETCHED = 'PAY_METHODS_FETCHED';

export const PAY_WAYS_FOR_PAY_METHOD_FETCHED =
  'PAY_WAYS_FOR_PAY_METHOD_FETCHED';

export const PAY_WAY_FETCHED = 'PAY_WAY_FETCHED';
export const SELECT_PAY_WAY = 'SELECT_PAY_WAY';

export const WARNING_FETCHED = 'WARNING_FETCHED';
export const DESCRIPTION_FETCHED = 'DESCRIPTION_FETCHED';
export const MANUAL_FETCHED = 'MANUAL_FETCHED';

export const INVOICE_CREATED = 'INVOICE_CREATED';
export const INIT_INVOICE_RESULT = 'INIT_INVOICE_RESULT';
export const SET_INVOICE_STATUS = 'SET_INVOICE_STATUS';
